import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "faq"
    }}>{`FAQ`}</h1>
    <details>
  <summary>How to use child theme?</summary>
      <br />
      <p>
In the theme package you should get a file named `storyhub-child.zip` . Upload this zip as theme and activate it. Make sure you have already Storyhub installed.
Both child and main theme must have to be installed but child theme have to be activated.
      </p>
    </details>
    <br />
    <details>
  <summary>How to optimize my site?</summary>
      <br />
      <div>
To optimize your site you can use below two free plugin. You can also configure CDN and for object caching you can also use `Redis` if your server support it.


You can use any other caching plugin.
      </div>
    </details>
    <br />
    <details>
  <summary>After deactivating and reactivating the theme my site is broken nothing is showing properly. How to fix?</summary>
      <br />
      <p>
make sure `Storyhub Manage` and all required plugin is active. If not please activate these plugins. These to plugin got deactivated when Storyhub theme is not active.
      </p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      